import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivitySummary, TranslationService, User } from '@lciapps/lci-core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivityLevelType } from '../../models/activity-level.model';
import { InviteStatus } from '../../models/activity-post.model';
import { ActivityStatus } from '../../models/activity-status.enum';
import { ActivitiesService } from '../../services/activities.service';
import { CreateService } from '../../services/create.service';

@Component({
  selector: 'app-activity-panel',
  templateUrl: './activity-panel.component.html',
  styleUrls: ['./activity-panel.component.css']
})
export class ActivityPanelComponent implements OnInit, OnChanges {
  @Input() public activity: any = new ActivitySummary();
  @Input() public owner = false;
  @Input() public displayChip = false;
  @Input() public displayActionLabels = false;
  // @Input() public isOfficer: boolean = false;
  @Input() public user: User = new User();
  @Input() public displayStatus = true;
  @Input() public centerButton: string;
  @Input() public noActive = false;
  @Output() public centerButtonClicked: EventEmitter<any> = new EventEmitter();
  public isOfficer = false;
  public chipValue = '';
  public chipIcon = '';
  public chipColor = '';
  public actionLabel = '';
  public actionKey = '';
  public statusColor = '';
  public startDate: Date;
  public endDate: Date;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private translationService: TranslationService,
    private activitiesService: ActivitiesService,
    private createService: CreateService
  ) {
    /**/
  }

  /**
   * Ng hoook
   */
  public ngOnChanges(): void {
    this.checkActionLabels();
    if (new Date(this.activity.endDate) < new Date()) {
      this.displayChip = false;
      return;
    }
    switch (this.activity.inviteStatus) {
      case InviteStatus.Invited:
        if (!this.owner) {
          this.chipValue = 'RSVP';
          this.chipIcon = 'check';
          this.chipColor = '#f0c611';
          this.translationService
            .getTranslationValue('lblRSVPNeeded')
            .subscribe(val => {
              this.chipValue = val;
            });
        } else {
          this.chipValue = '';
          this.chipIcon = '';
          this.chipColor = '';
          this.displayChip = false;
        }
        break;
      case InviteStatus.Denied:
        this.chipValue = 'Not Going';
        this.chipIcon = 'close';
        this.chipColor = '#b3b2b1';
        this.translationService
          .getTranslationValue('lblNotGoing')
          .subscribe(val => {
            this.chipValue = val;
          });
        break;
      case InviteStatus.Accepted:
        this.chipValue = 'Going';
        this.chipIcon = 'check';
        this.chipColor = '#00ab68';
        this.translationService
          .getTranslationValue('lblGoing')
          .subscribe(val => {
            this.chipValue = val;
          });
        break;
      case InviteStatus.Maybe:
        this.chipValue = 'Maybe';
        this.chipIcon = '';
        this.chipColor = '#f0c611';
        this.translationService
          .getTranslationValue('lblMaybe')
          .subscribe(val => {
            this.chipValue = val;
          });
        break;
    }
  }

  /**
   * Ng hook
   */
  public ngOnInit(): void {
    // console.log('act', this.activity);
    this.checkActionLabels();
    this.startDate = new Date(this.activity.startDate);
    const endDate = new Date(this.activity.endDate);
    if (
      this.startDate.getDate() !== endDate.getDate() ||
      this.startDate.getMonth() !== endDate.getMonth() ||
      this.startDate.getFullYear() !== endDate.getFullYear()
    ) {
      this.endDate = endDate;
    }
  }

  /**
   * Center button clicked - emit event
   * @param $event
   */
  public cbClicked($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.centerButtonClicked.emit();
  }

  /**
   * return if club sponsored
   * @returns {boolean}
   */
  private isClubSponsored(): boolean {
    const idx = this.activity.activityLevels.findIndex(item => {
      return item.activityLevel === ActivityLevelType.Club;
    });
    if (~idx) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * adsf
   */
  private checkActionLabels(): void {
    this.actionKey = '';
    if (this.activity.activityStatus === ActivityStatus.Draft) {
      this.actionLabel = 'Finish Draft';
      this.translationService
        .getTranslationValue('lblFinishDraft')
        .subscribe(val => {
          this.actionLabel = val;
        });
      this.statusColor = '#f0c611';
    } else if (this.activity.activityStatus === ActivityStatus.Reported) {
      this.actionLabel = 'Reported';
      this.actionKey = 'reported';
      this.translationService
        .getTranslationValue('lblReportedLC')
        .subscribe(val => {
          this.actionLabel = val;
        });
      this.statusColor = '#00ab68';
    } else if (
      this.createService.canReportActivity(this.activity, this.user)
    ) {
      this.actionLabel = 'Report Now';
      this.translationService
        .getTranslationValue('lblPublishNow')
        .subscribe(val => {
          this.actionLabel = val;
        });
      this.statusColor = '#990000';
    } else {
      this.actionLabel = this.activity.activityStatus;
    }
  }

  /**
   * Do appropriate aciton for activity
   */
  public doActionLabel(): void {
    if (this.activity.activityStatus === ActivityStatus.Draft) {
      this.router.navigate(
        ['../preview', { activityId: this.activity.activityId }],
        { relativeTo: this.route }
      );
    } else if (
      this.activity.isActivityOfficer &&
      new Date(this.activity.endDate) < new Date()
    ) {
      this.activitiesService
        .reportActivity(this.activity.activityId)
        .subscribe(res => {
          this.reloadActivity().subscribe(() => {
            this.checkActionLabels();
          });
        });
    }
  }

  /**
   * Loads the activity
   */
  public reloadActivity(): Observable<any> {
    return this.activitiesService.getActivity(this.activity.activityId).pipe(
      tap(res => {
        this.activity = res;
      })
    );
  }

  public encodeUrl(url: string) {
    return encodeURI(url);
  }


}
